.container {
    --search-content-max-width: 70.5rem;

    min-height: 100vh;
    width: 100%;
    background-color: var(--bi-neutral-5);
    height: 100%;
    padding-top: var(--bi-scale-8x);
    color: var(--bi-neutral-90);

    @media (width < 1600px) {
        --search-content-max-width: 55rem;
    }

    @media (width < 600px) {
        padding-top: var(--bi-scale-4x);
    }
}

.grid {
    max-width: var(--search-content-max-width);
    width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: var(--bi-scale-2x) var(--bi-scale-6x);

    @media (width < 1200px) {
        padding: 0 var(--bi-scale-4x);
    }

    @media (width < 840px) {
        grid-template-columns: repeat(8, 1fr);
    }
}

.header {
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-5x);
    grid-column: 1 / -1;

    > h1 {
        color: var(--bi-neutral-90);
        font-family: 'museo-slab', serif;
        font-size: 36px;
        font-weight: 500;
        line-height: 1.1;
        @media (width < 600px) {
            font-size: 28px;
            font-weight: 500;
            line-height: 1.3;
        }
    }

    > .searchRow {
        width: 100%;
        display: flex;
        gap: var(--bi-scale-5x);
        align-items: center;

        > :global(.bi-search) {
            flex: 1;
        }
    }
}

.filterDrawer {
    width: 100%; /* Prevent width changes if wide content is displayed. */
    .filterActionButton {
        flex: 1;
    }
}

.content {
    padding-top: var(--bi-scale-2x);
    padding-bottom: var(--bi-scale-8x);
}

.countContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 2.75rem;

    .count {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5;
        font-family: 'museo-sans', Arial, sans-serif;

        @media (width < 600px) {
            font-size: 0.875rem;
        }
    }

    .sorting {
        svg {
            transition: rotate 0.25s ease-in-out;
        }
        &[aria-expanded='true'] svg {
            rotate: 180deg;
        }
    }

    .sortingLabel {
        font-weight: 500;
    }
}

.results {
    grid-column: 3 / span 8;

    @media (width < 1600px) {
        grid-column: 2 / span 10;
    }

    @media (width < 840px) {
        grid-column: 1 / -1;
    }

    &:has(~ .filters) {
        grid-column: 1 / span 7;

        @media (width < 840px) {
            grid-column: 1 / -1;
        }
    }

    .list {
        display: flex;
        flex-direction: column;
        gap: var(--bi-scale-4x);
    }
}

.filters {
    align-self: flex-start;
    grid-column: 9 / span 4;
    grid-row: 2;
    display: flex;
    flex-direction: column;
    gap: inherit;
}
